import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './laundryDetails.css';
import LaundryDetailsData from './LaundryDetailsData';
import LaundryDetailsTable from './LaundryDetailsTable';
import LaundryImageManager from './LaundryImageManager';
import { colorOf } from '../../../../constants/areas';

function LaundryDetails() {
    const { bookingId } = useParams();
    const navigate = useNavigate();
    const [laundryDetails, setLaundryDetails] = useState({});
    const [loading, setLoading] = useState(true);
    const [userRole] = useState(localStorage.getItem('userRole'));


    useEffect(() => {
        const fetchLaundryDetails = async () => {
            try {
                const res = await axios.get(`/api/laundry/${bookingId}`);
                setLaundryDetails(res.data);
            } catch (err) {
                console.error("Error fetching laundry details:", err);
            } finally {
                setLoading(false);
            }
        };
        fetchLaundryDetails();
    }, [bookingId]);

    const handleEditClick = () => navigate(`/laundry/edit/${bookingId}`);

    if (loading) return <p>Loading laundry details...</p>;

    const {
        booking_id, property_id, client_name, building_name, unit_number,
        bedrooms, bathrooms, area
    } = laundryDetails;

    const areaColor = colorOf(area);

    return (
        <div className="laundry-details-container">
            <div className="header">
                <h2>
                    {(userRole === 'admin' || userRole === 'manager' || userRole === 'supervisor') ? (
                        <a style={{ color: "black", textDecoration: "none" }} href={`/bookings/${booking_id}`}>
                            Booking: #{String(booking_id).padStart(4, '0')}
                        </a>
                    ) : (
                        `Booking: #${String(booking_id).padStart(4, '0')}`
                    )}
                </h2>
                {(userRole === 'admin' || userRole === 'manager' || userRole === 'supervisor') && (
                    <button className="edit-button" onClick={handleEditClick}>
                        Edit Laundry Count
                    </button>
                )}
            </div>

            <div className="detail-full-width">
                <p><strong>Unit:</strong> <span style={{ color: areaColor, fontWeight: "500" }}>
                    {(userRole === 'admin' || userRole === 'manager' || userRole === 'supervisor') ? (
                        <a href={`/properties/${property_id}`} style={{ color: areaColor, textDecoration: "none" }}>
                            {`${client_name} - ${building_name} - Unit ${unit_number} (${bedrooms === 0 ? 'S' : bedrooms} - ${bathrooms})`}
                        </a>
                    ) : (
                        `${client_name} - ${building_name} - Unit ${unit_number} (${bedrooms === 0 ? 'S' : bedrooms} - ${bathrooms})`
                    )}
                </span></p>
            </div>

            <LaundryDetailsData bookingId={bookingId} />
            <LaundryDetailsTable bookingId={bookingId} />
            <LaundryImageManager bookingId={bookingId} />

        </div>
    );
}

export default LaundryDetails;
